import React from "react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { MediaTile } from "@/components/MediaTile";

/**
 * Displays a product/offer's full media set (cover + gallery photos/videos)
 * as a swipeable carousel. Falls back to a single static tile when there's
 * only one media item, so it never shows pointless arrows for one image.
 */
export const MediaGallery = ({ product, className = "" }) => {
  const items = [];
  if (product?.media_url) {
    items.push({ url: product.media_url, type: product.media_type || "image" });
  }
  (product?.gallery_images || []).forEach((url) => items.push({ url, type: "image" }));
  (product?.gallery_videos || []).forEach((url) => items.push({ url, type: "video" }));

  if (items.length === 0) return null;

  if (items.length === 1) {
    return (
      <div className={`relative overflow-hidden bg-muted ${className}`}>
        <MediaTile
          src={items[0].url}
          mediaType={items[0].type}
          alt={product?.name}
          className="absolute inset-0 w-full h-full object-cover"
        />
      </div>
    );
  }

  return (
    <Carousel className={`relative overflow-hidden bg-muted ${className}`} opts={{ loop: true }}>
      <CarouselContent className="h-full ml-0">
        {items.map((item, i) => (
          <CarouselItem key={i} className="pl-0 h-full">
            <div className="relative w-full h-full">
              <MediaTile
                src={item.url}
                mediaType={item.type}
                alt={`${product?.name} ${i + 1}`}
                className="absolute inset-0 w-full h-full object-cover"
              />
            </div>
          </CarouselItem>
        ))}
      </CarouselContent>
      <CarouselPrevious className="left-2 h-8 w-8" />
      <CarouselNext className="right-2 h-8 w-8" />
      <div className="absolute bottom-2 right-2 z-10 rounded-full bg-black/60 text-white text-[10px] px-2 py-0.5">
        {items.length} items
      </div>
    </Carousel>
  );
};
